export var SizeUtil;
(function (SizeUtil) {
    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const unitArray = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const num = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
        const unit = unitArray[i];
        const text = `${num} ${unit}`;
        return text;
    }
    SizeUtil.formatBytes = formatBytes;
})(SizeUtil || (SizeUtil = {}));
